import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { useTranslation } from 'react-i18next';

export function InputFormField() {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();
  return (
    <form.AppField name="titel">
      {(field) => (
        <field.TextInput
          label={t('domain.termine.sheet.fields.titel')}
          isRequired
        />
      )}
    </form.AppField>
  );
}
